import EquipmentManagerShop, {
  EquipmentManagerShopItem,
} from "./EquipmentManagerShop";

export default EquipmentManagerShop;
export { EquipmentManagerShop, EquipmentManagerShopItem };
